import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { AssetProps } from './Helpers';

import Card from './Card';

export const variations = {
  DEFAULT: Symbol('DEFAULT'),
  WIDER_ASSET: Symbol('WIDER_ASSET'),
  BILLBOARD_AD: Symbol('BILLBOARD_AD'),
  NARROW: Symbol('NARROW'),
};

const variationsDefaults = {
  [variations.DEFAULT]: {
    variationClassName: 'storycard--default-variation',
    aspectRatios: ['all_1x1'],
  },
  [variations.WIDER_ASSET]: {
    variationClassName: 'storycard--wider-asset-variation',
    aspectRatios: ['all_1x1', 'desktop_2x1'],
  },
  [variations.BILLBOARD_AD]: {
    variationClassName: 'storycard--billboard-variation',
    aspectRatios: ['all_388x100'],
  },
  [variations.NARROW]: {
    variationClassName: 'storycard--narrow-variation',
    aspectRatios: ['all_8x10'],
  },
};

export default class StoryCard extends Component {
  render() {
    const {
      bodyFontSize,
      variation,
      className,
      anchor,
      images,
      header,
      subHeader,
      copy,
      richTextCopy,
      points,
      links,
      align,
      verticalAlign,
      textColor,
      backgroundColor,
      overlayColor,
      aspectRatios,
      theme,
    } = this.props;

    const variationDefaults = variation && variationsDefaults[variation];
    const parsedAspectRatios = aspectRatios?.length ? aspectRatios : variationDefaults.aspectRatios;

    return (
      <section
        id={anchor || undefined}
        className={classNames('storycard', variationDefaults.variationClassName, {
          'storycard--left-align': align ? align.toLowerCase() === 'left' : true,
          'storycard--right-align': align?.toLowerCase() === 'right',
        })}
        data-testid="storycard"
      >
        <Card
          bodyFontSize={bodyFontSize || 'XL' }
          key={1}
          className="storycard__asset"
          images={images}
          backgroundColor={backgroundColor}
          textColor={textColor}
          overlayColor={overlayColor}
          aspectRatios={parsedAspectRatios}
          theme={theme || 'dark'}
        />
        <Card
          bodyFontSize={bodyFontSize || 'XL'}
          key={2}
          className={classNames('storycard__content', className)}
          header={header}
          subHeader={subHeader}
          textColor={textColor}
          copy={copy}
          align={align}
          verticalAlign={verticalAlign}
          richTextCopy={richTextCopy}
          points={points}
          links={links}
          backgroundColor={backgroundColor}
          overlayColor={overlayColor}
        />
      </section>
    );
  }
}

StoryCard.defaultProps = {
  variation: variations.DEFAULT,
};

StoryCard.propTypes = {
  bodyFontSize: PropTypes.string,
  points: PropTypes.array,
  images: PropTypes.arrayOf(AssetProps),
  anchor: PropTypes.string,
  copy: PropTypes.string,
  align: PropTypes.string,
  subHeader: PropTypes.string,
  header: PropTypes.string,
  theme: PropTypes.string,
};
